import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { compareObjects } from '../../../../functions/utils/comapareObjects';
import { useUIStore } from '../../../../hooks/stores/uiStore';
import { StateViewInfo, stateViewsInfo } from '../../../../info/stateViewsInfo';
import { AnyTaskViewButton } from './AnyTaskViewButton';
import { CurrentViewButton } from './CurrentViewButton';
import { DefaultViewButton } from './DefaultViewButton';

export const StylingTargetStatePanel = () => {
  const [UIData] = useUIStore();

  const [lastStateViewData, setLastStateViewData] = useState<StateViewInfo>({
    significantLauncherState: ['isAppInstalled', 'false'],
    iconClassName: 'icon-not-installed',
    subIconClassName: undefined,
  } as StateViewInfo);

  const stateViewData =
    Object.values(stateViewsInfo).find((data) =>
      compareObjects(UIData.currentLauncherState, data.significantLauncherState)
    ) || lastStateViewData;

  const isCurrentViewTask = stateViewData?.subIconClassName !== undefined;

  useEffect(() => {
    setLastStateViewData(stateViewData);
  }, [stateViewData]);

  return (
    <Container>
      <DefaultViewButton />
      <CurrentViewButton />
      {isCurrentViewTask && <AnyTaskViewButton />}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 20px;

  gap: 25px;

  & > * {
    animation: slideLeft 0.5s;
  }
`;
